var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMistral = function SvgMistral(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M189.08 303.228H94.587l.044-94.446h94.497l-.048 94.446z",
    fill: "#1c1c1b",
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M283.528 397.674h-94.493l.044-94.446h94.496l-.047 94.446z",
    fill: "#1c1c1b",
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M283.575 303.228H189.08l.046-94.446h94.496l-.047 94.446z",
    fill: "#1c1c1b",
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M378.07 303.228h-94.495l.044-94.446h94.498l-.047 94.446zM189.128 208.779H94.633l.044-94.448h94.498l-.047 94.448zM378.115 208.779h-94.494l.045-94.448h94.496l-.047 94.448zM94.587 303.227H.093l.044-96.017h94.496l-.046 96.017z",
    fill: "#1c1c1b",
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.633 208.779H.138l.046-94.448H94.68l-.047 94.448z",
    fill: "#1c1c1b",
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.68 115.902H.185L.23 19.885h94.498l-.047 96.017zM472.657 114.331h-94.495l.044-94.446h94.497l-.046 94.446zM94.54 399.244H.046l.044-97.588h94.497l-.047 97.588z",
    fill: "#1c1c1b",
    fillRule: "nonzero"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M94.495 492.123H0l.044-94.446H94.54l-.045 94.446zM472.563 303.228H378.07l.044-94.446h94.496l-.047 94.446zM472.61 208.779h-94.495l.044-94.448h94.498l-.047 94.448z",
    fill: "#1c1c1b",
    fillRule: "nonzero"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M472.517 397.674h-94.494l.044-94.446h94.497l-.047 94.446z",
    fill: "#1c1c1b",
    fillRule: "nonzero"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M472.47 492.121h-94.493l.044-96.017h94.496l-.047 96.017z",
    fill: "#1c1c1b",
    fillRule: "nonzero"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M228.375 303.22h-96.061l.046-94.446h96.067l-.052 94.446z",
    fill: "#ff7000",
    fillRule: "nonzero"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M322.827 397.666h-94.495l.044-96.018h94.498l-.047 96.018z",
    fill: "#ff4900",
    fillRule: "nonzero"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M324.444 303.22h-97.636l.046-94.446h97.638l-.048 94.446z",
    fill: "#ff7000",
    fillRule: "nonzero"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M418.938 303.22h-96.064l.045-94.446h96.066l-.047 94.446z",
    fill: "#ff7000",
    fillRule: "nonzero"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M228.423 208.77H132.36l.045-94.445h96.066l-.05 94.446zM418.985 208.77H322.92l.044-94.445h96.069l-.048 94.446z",
    fill: "#ffa300",
    fillRule: "nonzero"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M133.883 304.79H39.392l.044-96.017h94.496l-.049 96.017z",
    fill: "#ff7000",
    fillRule: "nonzero"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M133.929 208.77H39.437l.044-95.445h94.496l-.048 95.445z",
    fill: "#ffa300",
    fillRule: "nonzero"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M133.976 114.325H39.484l.044-94.448h94.497l-.05 94.448zM511.954 115.325h-94.493l.044-95.448h94.497l-.048 95.448z",
    fill: "#ffce00",
    fillRule: "nonzero"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M133.836 399.667H39.345l.044-96.447h94.496l-.049 96.447z",
    fill: "#ff4900",
    fillRule: "nonzero"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M133.79 492.117H39.3l.044-94.448h94.496l-.049 94.448z",
    fill: "#ff0107",
    fillRule: "nonzero"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M511.862 303.22h-94.495l.046-94.446h94.496l-.047 94.446z",
    fill: "#ff7000",
    fillRule: "nonzero"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M511.907 208.77h-94.493l.044-94.445h94.496l-.047 94.446z",
    fill: "#ffa300",
    fillRule: "nonzero"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M511.815 398.666h-94.493l.044-95.447h94.496l-.047 95.447z",
    fill: "#ff4900",
    fillRule: "nonzero"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M511.77 492.117h-94.496l.046-94.448h94.496l-.047 94.448z",
    fill: "#ff0107",
    fillRule: "nonzero"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMistral);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "mistral.cb8a20d83dd6ee8b582f4f5037b5b249.svg";